import { useMutation, useQuery, useQueryClient } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { TenantSettingsControllerService } from "../../services";

export const useGetNotificationPreferences = (tenantId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_NOTIFICATION_PREFERENCES, tenantId];

  const query = useQuery(
    queryKey,
    () =>
      handleRequest(
        TenantSettingsControllerService.tenantSettingsControllerGetNotificationPreferences(
          tenantId
        )
      ),
    {
      enabled: !tenantId || !!tenantId,
    }
  );

  return {
    ...query,
  };
};

export const useChangeNotificationPreferences = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ tenantId, requestBody }: { tenantId: string; requestBody: any }) =>
      handleRequest(
        TenantSettingsControllerService.tenantSettingsControllerUpdateNotificationPreferences(
          tenantId,
          requestBody
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Property updated successfully:", response);
        queryClient.invalidateQueries(QUERY.GET_NOTIFICATION_PREFERENCES);
      },
    }
  );

  return {
    ...mutation,
  };
};
